import { render, staticRenderFns } from "./ImageUploadByCamera.vue?vue&type=template&id=d361ba0e&scoped=true&"
import script from "./ImageUploadByCamera.vue?vue&type=script&lang=js&"
export * from "./ImageUploadByCamera.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadByCamera.vue?vue&type=style&index=0&id=d361ba0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d361ba0e",
  null
  
)

export default component.exports